module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_background_image2.2fc727f3.svg";